module.exports = __webpack_public_path__ + "static/media/workingmemory-words-1.111e91e2.mp3";